import { View, ViewDensity } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";
import { RequiredAccountAssignedCell } from "./cells/RequiredAccountAssignedCell";
import { RequiredAccountNameCell } from "./cells/RequiredAccountNameCell";
import { RequiredAccountNameHeaderCell } from "./cells/RequiredAccountNameHeaderCell";
import { createRequiredAccountTextCell } from "./cells/RequiredAccountTextCell";
import { RequiredAccountRow } from "./requiredAccountsMapping";
import styles from "./RequiredAccountsMapping.module.scss";

export enum RequiredAccountsColumn {
    NAME = "name",
    ASSIGNED = "assigned",
    DESCRIPTION = "description",
}

export const requiredAccountsViewConfig: ViewConfig<
    RequiredAccountRow,
    RequiredAccountsColumn,
    never
> = {
    columns: {
        [RequiredAccountsColumn.NAME]: {
            accessorKey: "requiredAccountName",
            name: "Required account",
            header: "Required account",
            headerCell: RequiredAccountNameHeaderCell,
            cell: RequiredAccountNameCell,
            immutable: true,
            minSize: 260,
            maxSize: 260,
        },
        [RequiredAccountsColumn.ASSIGNED]: {
            accessorKey: "assignedAccountId",
            name: "Assigned to",
            header: "Assigned to",
            cell: RequiredAccountAssignedCell,
            minSize: 260,
            maxSize: 260,
        },
        [RequiredAccountsColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            cell: createRequiredAccountTextCell({
                field: "description",
                className: styles.description,
            }),
            minSize: 240,
        },
    },
};

export const requiredAccountsView: View = {
    columns: [
        { id: RequiredAccountsColumn.NAME },
        { id: RequiredAccountsColumn.ASSIGNED },
        { id: RequiredAccountsColumn.DESCRIPTION },
    ],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
};
